<template>

    <div class="progress">
        <span class="progress-left">
            <span :class="getColor()" class="progress-bar" :style="transformLeft"></span>
        </span>
        <span class="progress-right">
            <span :class="getColor()" class="progress-bar" :style="transformRight"></span>
        </span>
        <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center" :class="getBackgroundColor()">
            <p class="text-center progress-percentage">
               {{progress}}%
            </p>
            <p class="text-center progress-date">
                {{ deadline.date | date_named_month_short }}
            </p>
        </div>
    </div>

</template>

<script>

    export default {
        name: 'design-2021-quest-deadline-progress',
        props: ['deadline'],
        data() {
            var progress        = this.deadline.progress;
            var maxProgress     = Math.min(100, this.deadline.progress);
            var degrees         = maxProgress / 100 * 360 / 2;
            var transformLeft   = '';
            var transformRight  = '';

            if(maxProgress > 0)
            {
                if(maxProgress <= 50)
                {
                    transformRight  = 'transform: rotate('+degrees+'deg)';
                }
                else
                {
                    transformRight  = 'transform: rotate(180deg)';
                    transformLeft   = 'transform: rotate('+degrees+'deg)';
                }
            }

            return {
                progress:           progress,
                degrees:            degrees,
                transformLeft:      transformLeft,
                transformRight:     transformRight
            }
        },
        watch: {
            deadline(value) {
                var progress        = this.deadline.progress;
                var maxProgress     = Math.min(100, this.deadline.progress);
                var degrees         = maxProgress / 100 * 360 / 2;
                var transformLeft   = '';
                var transformRight  = '';

                if(maxProgress > 0)
                {
                    if(maxProgress <= 50)
                    {
                        transformRight  = 'transform: rotate('+degrees+'deg)';
                    }
                    else
                    {
                        transformRight  = 'transform: rotate(180deg)';
                        transformLeft   = 'transform: rotate('+degrees+'deg)';
                    }
                }

                this.progress=           progress;
                this.degrees=            degrees;
                this.transformLeft=      transformLeft;
                this.transformRight=     transformRight;
            }
        },
        methods: {
            getColor() {
                if(this.deadline.usermissions.length > 0)
                {
                    if(this.deadline.usermissions[0].status == 2)
                    {
                        return 'border-warning';
                    }
                    else if(this.deadline.usermissions[0].status == 3)
                    {
                        return 'border-success';
                    }
                }

                return 'border-primary';
            },
            getBackgroundColor() {
                if(this.deadline.usermissions.length > 0)
                {
                    if(this.deadline.usermissions[0].status == 2)
                    {
                        return 'bg-inverse-warning';
                    }
                    else if(this.deadline.usermissions[0].status == 3)
                    {
                        return 'bg-inverse-success';
                    }
                }

                return 'bg-inverse-primary';
            },
        }
    }

</script>

<style scoped lang="scss">

.progress {
    width: 80px;
    height: 80px;
    background: none;
    position: relative;
    float: left;
    margin: 5px;
}

.progress::after {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 6px solid #eee;
    position: absolute;
    top: 0;
    left: 0;
}

.progress>span {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
}

.progress .progress-left {
    left: 0;
}

.progress .progress-bar {
    width: 100%;
    height: 100%;
    background: none;
    border-width: 6px;
    border-style: solid;
    position: absolute;
    top: 0;
    border-radius: 0px;
}

.progress .progress-left .progress-bar {
    left: 100%;
    border-top-right-radius: 80px;
    border-bottom-right-radius: 80px;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
}

.progress .progress-right {
    right: 0;
}

.progress .progress-right .progress-bar {
    left: -100%;
    border-top-left-radius: 80px;
    border-bottom-left-radius: 80px;
    border-right: 0;
    -webkit-transform-origin: center right;
    transform-origin: center right;
}

.progress {
    .progress-value {
        position: absolute;
        flex-wrap: wrap;
        flex-direction: column;
        top: 0;
        left: 0;

        .progress-percentage {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            font-weight: $font-weight-bold;
        }

        .progress-date {
                margin-bottom: 0;
        }
    }

}

</style>
